import { InteracBulkPayoutTransactionResponse, TransactionIdAndType, TransactionType } from 'vopay';
import { useEffect, FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import InteracBulkPayoutTransactionInfo from './InteracBulkPayoutTransactionInfo';
import useFetchInteracBulkPayoutTransaction from '../../hooks/useApi/useFetchInteracBulkPayoutTransaction';
import useAccountBearer from '@/hooks/useApi/useAccountBearer';

const InteracBulkPayoutTransactionContainer: FC<TransactionIdAndType> = ({
  TransactionID,
  Type,
}: TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const token = useAccountBearer(accountId);

  const [InteracBulkPayout, getInteracBulkPayoutTransaction] = useFetchInteracBulkPayoutTransaction({
    bearer: token,
  });

  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<InteracBulkPayoutTransactionResponse>();

  useEffect(() => {
    if (!token) return;

    if (Type === TransactionType.INTERACT_BULK_PAYOUT) {
      getInteracBulkPayoutTransaction(TransactionID);
    }
  }, [currentTransactionId, token]);

  useEffect(() => {
    if (InteracBulkPayout) {
      setTransaction(InteracBulkPayout);
    }
  }, [InteracBulkPayout]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>{transaction && <InteracBulkPayoutTransactionInfo transaction={transaction} />}</div>
  );
};

export default InteracBulkPayoutTransactionContainer;
